import type { Adventure } from '../../types'

// Age 5: Sums to Ten - All ways to make 10
export const sumsToTenAdventure: Adventure = {
  id: 'sums-to-ten',
  title: 'Sums to Ten',
  theme: 'addition',
  targetAge: '5',
  difficulty: 'medium',
  estimatedDuration: 10,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello math champion! I'm Tilly! Today we're discovering all the ways to make 10!",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Did you know 6 and 4 make 10? Let's find more number pairs that add up to 10!",
      duration: 6,
      background: 'number-world'
    },
    choice1: [
      {
        id: 'find-pairs',
        label: "Find pairs!",
        tillyLine: "Let's discover number friends that equal 10!",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '7 + ? = 10',
      tillyPrompt: '7 plus what number equals 10?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      num1: 7,
      num2: 3
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Excellent! Now, if I have 8, how many more do I need to reach 10?",
      duration: 5,
      background: 'math-forest'
    },
    choice2: [
      {
        id: 'complete-ten',
        label: "Complete to 10!",
        tillyLine: "8 plus something equals 10...",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '8 + ? = 10',
      tillyPrompt: '8 plus what makes 10?',
      options: [
        { id: '1', label: '1', isCorrect: false },
        { id: '2', label: '2', isCorrect: true },
        { id: '3', label: '3', isCorrect: false }
      ],
      num1: 8,
      num2: 2
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a 10-making master! Let's try the big challenge: 9 plus what equals 10?",
        duration: 5,
        background: 'pattern-world'
      },
      quizzes: [
        {
          id: 'challenge-quiz-1',
          type: 'simple-addition',
          question: '9 + ? = 10',
          tillyPrompt: '9 plus what number equals 10?',
          options: [
            { id: '0', label: '0', isCorrect: false },
            { id: '1', label: '1', isCorrect: true },
            { id: '2', label: '2', isCorrect: false }
          ],
          num1: 9,
          num2: 1
        } as any,
        {
          id: 'challenge-quiz-2',
          type: 'simple-addition',
          question: '5 + ? = 10',
          tillyPrompt: 'What plus 5 makes 10?',
          options: [
            { id: '4', label: '4', isCorrect: false },
            { id: '5', label: '5', isCorrect: true },
            { id: '6', label: '6', isCorrect: false }
          ],
          num1: 5,
          num2: 5
        } as any
      ]
    },
    reward: {
      tillyLine: "Unbelievable! You know all the ways to make 10! You're a true Sums to Ten champion!",
      badgeName: 'Ten Master',
      badgeIcon: '🔟',
      nextPreview: 'Next time, we\'ll mix addition AND subtraction!'
    }
  }
}

// Tilly reactions for sums to ten
export const tillyTenCorrect = [
  "That's it! Those numbers make 10!",
  "Perfect! You know your tens!",
  "Yes! 10 is a special number!",
  "You're a 10-making expert!",
  "Bingo! Those add up to 10!",
  "Amazing! You found the missing number!",
  "Exactly right! Great number sense!"
]

export const tillyTenWrong = [
  "Not quite! Count up to 10 to check!",
  "Close! Try a different number!",
  "Almost! Think about what plus that equals 10!",
  "That's not 10 yet! Try again!",
  "Good try! Let's count together!",
  "Not that one! Keep looking for 10!",
  "Oops! Let's find the right partner for 10!"
]
